// @flow
import React, {useEffect} from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import {useHistory} from 'react-router-dom';
import asterisk from '../../../../../assets/img/logistics/asterisk.svg';
import message from '../../../../../assets/img/logistics/message.svg';
import star from '../../../../../assets/img/logistics/star.svg';
import defaultShippingExample from '../../../../../assets/img/logistics/defaultShippingExample.png';
import {useResetState, useUpdateShippingMethodActive} from '../utils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    backgroundColor: 'white',
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
    },
    border: '1px solid #dbdbe0',
    borderTop: 'none',
    paddingTop: theme.spacing(2),
  },
  divider: {
    background: '#e8e8ed',
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  checkboxLabel: {
    color: colors.grey700,
    fontWeight: 500,
    fontSize: '0.875rem',
    margin: theme.spacing(3, 0),
  },
  description: {
    fontSize: '0.875rem',
    color: colors.grey700,
    padding: theme.spacing(0, 3),
  },
  bold: {
    fontWeight: 600,
  },
  horizontal: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 3),
  },
  left: {
    marginBottom: theme.spacing(3),
  },
  title: {
    marginTop: theme.spacing(4),
    fontSize: '0.875rem',
    color: colors.grey900,
    fontWeight: 600,
  },
  greyText: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    color: colors.grey700,
    fontSize: '0.875rem',
  },
  img: {
    marginRight: theme.spacing(1),
  },
  exampleSpace: {
    // marginLeft: 'auto',
    // marginBottom: theme.spacing(2),
  },
  exampleTitle: {
    margin: theme.spacing(3, 0, 1, 1),
    fontSize: '0.875rem',
    fontWeight: 500,
    color: colors.purple3,
  },
  exampleImg: {
    maxWidth: '100%',
    marginBottom: theme.spacing(2),
  },
  alert: {
    width: '100%',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(2),
    },
  },
}));

export default function LogisticsShippingDefault() {
  const classes = useStyles();
  const history = useHistory();

  const {savingMethodSuccess} = useUpdateShippingMethodActive();
  const {resetState} = useResetState();

  useEffect(() => {
    if (savingMethodSuccess) history.push('/configure/logistics/shipping');
  }, [history, savingMethodSuccess]);

  useEffect(() => {
    return () => {
      resetState();
    };
  }, [resetState]);

  return (
    <div className={classes.root}>
      {/* <Divider className={classes.divider} /> */}
      <Typography className={classes.description}>
        Se recomienda habilitar esta opción cuando no tenemos claro el costo de
        envío. Sólo es válido para método de pago{' '}
        <span className={classes.bold}>Pedir por WhatsApp</span>.
      </Typography>
      <div className={classes.horizontal}>
        <div className={classes.left}>
          <Typography className={classes.title}>¿Cómo funciona?</Typography>
          <Typography className={classes.greyText}>
            <img className={classes.img} src={asterisk} alt="" /> El costo de
            envío aparece como por confirmar
          </Typography>
          <Typography className={classes.greyText}>
            <img className={classes.img} src={message} alt="" /> La única opción
            de pago disponible es Pedir por WhatsApp
          </Typography>
          <Typography className={classes.greyText}>
            <img className={classes.img} src={star} alt="" /> Ofrece una
            cotización personalizada y coordínalo por interno.
          </Typography>
        </div>
        <div className={classes.exampleSpace}>
          <Typography className={classes.exampleTitle}>Ejemplo</Typography>
          <img
            className={classes.exampleImg}
            src={defaultShippingExample}
            alt=""
          />
        </div>
      </div>
    </div>
  );
}
